// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","root":"root-23eHZ","icon":"icon-1aOMq","account":"account-1S8rx","payload":"payload-2Widk"};